var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer_comp" }, [
    _vm.$route.query.origin == "zn"
      ? _c("div", [
          _c("div", {
            staticStyle: { "line-height": "2", background: "#fff" },
            domProps: { innerHTML: _vm._s(_vm.copyRightHtml) }
          })
        ])
      : _c("div", [
          _vm.envFlag
            ? _c("div", [
                _c("div", { domProps: { innerHTML: _vm._s(_vm.copyRight) } })
              ])
            : _c("div", [_vm._m(0)]),
          _vm._v(" "),
          _c("div", { staticClass: "footer-item" }, [
            _vm._v("技术支持:北京朗从科技有限公司")
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Copyright © 2019-2021 乌鲁木齐市教育局 版权所有 "),
      _c("a", { attrs: { href: "http://www.beian.miit.gov.cn" } }, [
        _vm._v("新ICP备19001192号")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }